/* ALO Matcha — display-side currency conversion.
   Base/checkout currency is USD (store currency). This converts DISPLAYED prices
   to the visitor's currency by detected country (window.aloGeo.country) or a manual
   pick (persisted). Checkout still processes in USD. Lebanon + unknown => USD.
   Rates: fetched live daily from open.er-api.com (no key, CORS), cached 24h in
   localStorage. The `rates` table below is the OFFLINE FALLBACK if the API fails. */
(function () {
  if (window.aloCurrency) return;

  var CONFIG = {
    base: 'USD',
    // 1 USD = X. FALLBACK only — live rates from open.er-api.com override these daily.
    rates: { USD: 1, EUR: 0.92, GBP: 0.79, AUD: 1.52, NZD: 1.66, CAD: 1.37, CHF: 0.88, JPY: 150, SGD: 1.34, HKD: 7.8, SEK: 10.6, NOK: 10.7, DKK: 6.9, INR: 84,
             AED: 3.67, SAR: 3.75, QAR: 3.64, KWD: 0.307, BHD: 0.376, OMR: 0.385, JOD: 0.709,
             TRY: 32.5, EGP: 49, IQD: 1310, YER: 250, LYD: 4.85, TND: 3.13, DZD: 134, MAD: 9.95, SDG: 600 },
    // Active Shopify Markets country -> local currency. LB + anything unmapped => USD.
    countryToCurrency: {
      LB: 'USD', US: 'USD',
      SA: 'SAR', AE: 'AED', KW: 'KWD', QA: 'QAR', BH: 'BHD', OM: 'OMR', JO: 'JOD',
      GB: 'GBP', CA: 'CAD',
      DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', BE: 'EUR', IE: 'EUR', AT: 'EUR', PT: 'EUR', FI: 'EUR', GR: 'EUR', LU: 'EUR',
      TR: 'TRY', EG: 'EGP', IQ: 'IQD', YE: 'YER', LY: 'LYD', TN: 'TND', DZ: 'DZD', MA: 'MAD', SD: 'SDG',
      AU: 'AUD', NZ: 'NZD', CH: 'CHF', JP: 'JPY', SG: 'SGD', HK: 'HKD', SE: 'SEK', NO: 'NOK', DK: 'DKK', IN: 'INR'
    },
    // Currencies shown in the manual picker dropdown (the markets we actively serve).
    order: ['USD', 'SAR', 'AED', 'KWD', 'QAR', 'BHD', 'OMR', 'JOD', 'EUR', 'GBP', 'CAD', 'TRY', 'EGP'],
    labels: { USD: 'USD $', EUR: 'EUR €', GBP: 'GBP £', CAD: 'CAD $', AUD: 'AUD $', NZD: 'NZD $', CHF: 'CHF', JPY: 'JPY ¥', SGD: 'SGD $', HKD: 'HKD $', INR: 'INR ₹', SEK: 'SEK', NOK: 'NOK', DKK: 'DKK',
              AED: 'AED', SAR: 'SAR', QAR: 'QAR', KWD: 'KWD', BHD: 'BHD', OMR: 'OMR', JOD: 'JOD',
              TRY: 'TRY ₺', EGP: 'EGP £', IQD: 'IQD', YER: 'YER', LYD: 'LYD', TND: 'TND', DZD: 'DZD', MAD: 'MAD', SDG: 'SDG' }
  };

  var STORAGE = 'alo_currency';
  var COUNTRY_KEY = 'alo_last_country';
  var SYMBOL_CCY = { USD: 1, EUR: 1, GBP: 1, CAD: 1, AUD: 1, NZD: 1, SGD: 1, HKD: 1, JPY: 1, INR: 1, CHF: 1 };

  // SERVER-rendered ({{ money }}) price spans only. JS-rendered prices (cart drawer,
  // variant, predictive search) go through formatMoney delegation instead.
  var SELECTORS = [
    '.product-card__price', '.product-main__price', '.product-main__price--now', '.product-main__price--was',
    '.price-item', '.alo-offer__price-now', '.alo-offer__price-was',
    '.fh-bundle__price', '.fh-bundle__price-now', '.fh-bundle__price-was',
    '.pairs-item__price', '.mgd__related-price', '.evt-detail__related-price',
    '.cart-page__line-price', '.cart-page__item-price', '.cart-page__item-total', '.cart-page__subtotal-amount'
  ].join(',');

  // Source of truth = the active Shopify Markets country (localization.country.iso_code,
  // exposed as window.aloGeo.country). No third-party IP geolocation. When the visitor
  // switches country via the Shopify country selector the page reloads and this updates.
  function activeCountry() {
    return ((window.aloGeo && window.aloGeo.country) || '').toUpperCase();
  }
  function currencyForCountry(cc) {
    var c = CONFIG.countryToCurrency[cc];
    return (c && CONFIG.rates[c]) ? c : 'USD';
  }

  // Currency follows the active country's local currency (Lebanon + unmapped => USD).
  // A manual currency pick is honored only WHILE the country is unchanged; switching
  // country clears the manual pick so prices always track the selected market.
  function resolveCode() {
    var cc = activeCountry();
    var last = null;
    try { last = localStorage.getItem(COUNTRY_KEY); } catch (e) {}
    if (cc && cc !== last) {
      try { localStorage.setItem(COUNTRY_KEY, cc); localStorage.removeItem(STORAGE); } catch (e) {}
      return currencyForCountry(cc);
    }
    var saved = null;
    try { saved = localStorage.getItem(STORAGE); } catch (e) {}
    if (saved && CONFIG.rates[saved]) return saved;
    return currencyForCountry(cc);
  }

  var current = resolveCode();

  function format(usdCents, code) {
    code = code || current;
    var rate = CONFIG.rates[code] || 1;
    var amount = (Math.round(usdCents) / 100) * rate;
    try {
      return new Intl.NumberFormat('en', {
        style: 'currency', currency: code,
        currencyDisplay: SYMBOL_CCY[code] ? 'symbol' : 'code'
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function parseUsd(text) {
    var cleaned = (text || '').replace(/[^0-9.]/g, '');
    var f = parseFloat(cleaned);
    return isNaN(f) ? null : f;
  }

  function convertStatic(scope) {
    scope = scope || document;
    var els = scope.querySelectorAll ? scope.querySelectorAll(SELECTORS) : [];
    Array.prototype.forEach.call(els, function (el) {
      // only convert leaf price spans, never containers (would wipe sibling labels)
      if (el.children && el.children.length) return;
      var usd;
      if (el.hasAttribute('data-alo-usd')) {
        usd = parseFloat(el.getAttribute('data-alo-usd'));
      } else {
        usd = parseUsd(el.textContent);
        if (usd == null) return;
        el.setAttribute('data-alo-usd', usd);
      }
      el.textContent = format(usd * 100);
    });
    updateNotes();
  }

  function updateNotes() {
    document.querySelectorAll('.js-currency-note').forEach(function (n) {
      n.hidden = (current === 'USD');
      var codeEl = n.querySelector('.js-currency-note-code');
      if (codeEl) codeEl.textContent = current;
    });
  }

  function updateSelectors() {
    document.querySelectorAll('.js-currency-select').forEach(function (sel) { sel.value = current; });
  }

  function buildSelectors() {
    document.querySelectorAll('.js-currency-select').forEach(function (sel) {
      if (sel.dataset.built) return;
      sel.dataset.built = '1';
      sel.innerHTML = CONFIG.order.map(function (c) {
        return '<option value="' + c + '">' + (CONFIG.labels[c] || c) + '</option>';
      }).join('');
      sel.value = current;
      sel.addEventListener('change', function () { setCurrency(sel.value); });
    });
  }

  function setCurrency(code) {
    if (!CONFIG.rates[code] || code === current) { updateSelectors(); return; }
    current = code;
    try { localStorage.setItem(STORAGE, code); } catch (e) {}
    convertStatic();
    updateSelectors();
    document.dispatchEvent(new CustomEvent('alo:currency:changed', { detail: { code: code } }));
    // refresh any JS-rendered cart so formatMoney re-runs in the new currency
    document.dispatchEvent(new CustomEvent('alo:cart:updated'));
  }

  // ---- live FX rates (free, no key, CORS) with 24h cache + fixed-table fallback ----
  var FX_CACHE = 'alo_fx_cache';
  var FX_TTL = 24 * 60 * 60 * 1000;
  var FX_URL = 'https://open.er-api.com/v6/latest/USD';

  function applyRates(rates) {
    if (!rates) return false;
    var changed = false;
    Object.keys(CONFIG.rates).forEach(function (code) {
      if (typeof rates[code] === 'number' && rates[code] > 0) { CONFIG.rates[code] = rates[code]; changed = true; }
    });
    return changed;
  }

  function loadLiveRates() {
    try {
      var raw = localStorage.getItem(FX_CACHE);
      if (raw) {
        var c = JSON.parse(raw);
        if (c && c.rates && c.ts && (Date.now() - c.ts) < FX_TTL) { applyRates(c.rates); return; }
      }
    } catch (e) {}
    if (!window.fetch) return;
    var ctrl = window.AbortController ? new AbortController() : null;
    var to = ctrl ? setTimeout(function () { ctrl.abort(); }, 6000) : null;
    fetch(FX_URL, { signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (to) clearTimeout(to);
        if (!data || data.result !== 'success' || !data.rates) return;
        var subset = {};
        Object.keys(CONFIG.rates).forEach(function (code) { if (typeof data.rates[code] === 'number') subset[code] = data.rates[code]; });
        try { localStorage.setItem(FX_CACHE, JSON.stringify({ ts: Date.now(), rates: subset })); } catch (e) {}
        if (applyRates(subset)) convertStatic();
      })
      .catch(function () { if (to) clearTimeout(to); /* keep fixed fallback rates */ });
  }

  // The native Shopify country selector labels every country with the MARKET currency
  // (USD here, since Shopify Payments is off). Rewrite each option to show the country's
  // local DISPLAY currency instead, matching the on-page prices. e.g. "Saudi Arabia (SAR)".
  function relabelCountries() {
    var opts = document.querySelectorAll('.header__country-select option, .js-country-select option');
    Array.prototype.forEach.call(opts, function (opt) {
      var iso = (opt.value || '').toUpperCase();
      if (!iso) return;
      var name = opt.textContent.replace(/\s*\([^)]*\)\s*$/, '').trim();
      opt.textContent = name + ' (' + currencyForCountry(iso) + ')';
    });
  }

  function init() { loadLiveRates(); buildSelectors(); updateSelectors(); convertStatic(); relabelCountries(); }

  window.aloCurrency = {
    get code() { return current; },
    format: function (cents) { return format(cents); },
    convertStatic: convertStatic,
    set: setCurrency,
    rebuild: init,
    relabelCountries: relabelCountries,
    config: CONFIG
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-convert static prices when content changes
  document.addEventListener('alo:cart:updated', function () { setTimeout(convertStatic, 60); });
  document.addEventListener('alo:cart:opened', function () { setTimeout(convertStatic, 60); });
})();
